import { Box, Grid } from '@material-ui/core';
import React from 'react';
import { AutocompleteInput, required, TextInput } from 'react-admin';
import { getZ3PConfigValue } from '../../helper';
import useStyles from '../../QuickActions/styles';
import { commonVehicleColors } from '../../VehicleConstants';

const YMMTForm = ({
  years,
  makeList,
  modelList,
  trimList,
  vehicle,
  touched,
  handleTouched,
  handleChange,
  loadMakes,
  loadModels,
  loadTrims,
  setTrimList,
  setModelList,
}) => {
  const { skip_simple_services_to: skipSimpleServicesTo } = getZ3PConfigValue();

  const classes = useStyles();

  // Only require trim if the skip_simple_services_to value from z3p is "tires", or null
  // otherwise, trims are optional for detailing, or mechanical services
  const trimValidations =
    !skipSimpleServicesTo || skipSimpleServicesTo === 'tires'
      ? [required()]
      : [];

  const hasMakeError =
    !!makeList.length && !vehicle?.year?.make && touched.year.make;

  const hasModelError =
    !!modelList.length && !vehicle?.year?.model && touched.year.model;

  const hasTrimError =
    !!trimList.length && !vehicle?.year?.trim && touched.year.trim;

  return (
    <Box>
      <Grid
        container
        spacing={1}
        className={`${classes.formRoot} ${classes.width100}`}
      >
        <Grid item xs={12} sm={6} md={4}>
          <AutocompleteInput
            label="Year"
            source="year.year"
            choices={years}
            validate={[required()]}
            onChange={(value) => {
              handleChange('year', value);
              loadMakes(value);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <AutocompleteInput
            label="Make"
            source="year.make"
            choices={makeList}
            validate={[required()]}
            onChange={(value) => {
              handleChange('make', value);
              if (value !== 'other') {
                loadModels(value);
              } else {
                setTrimList([{ id: 'other', name: 'Other' }]);
                setModelList([{ id: 'other', name: 'Other' }]);
              }
            }}
            options={{
              disabled: makeList.length === 0 || !vehicle?.year?.year,
              error: hasMakeError,
            }}
            helperText={hasMakeError && 'Required'}
            onBlur={handleTouched('make')}
          />

          {vehicle?.year?.make === 'other' && (
            <TextInput
              source="custom.make"
              label="Custom Make"
              validate={[required()]}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          {!(modelList.length === 1 && vehicle?.year?.model === 'other') && (
            <AutocompleteInput
              label="Model"
              source="year.model"
              choices={modelList}
              validate={[required()]}
              onChange={(value) => {
                handleChange('model', value);
                if (value !== 'other') {
                  loadTrims(value);
                } else {
                  setTrimList([{ id: 'other', name: 'Other' }]);
                }
              }}
              options={{
                disabled: modelList.length === 0 || !vehicle?.year?.make,
                error: hasModelError,
              }}
              helperText={hasModelError && 'Required'}
              onBlur={handleTouched('model')}
            />
          )}

          {vehicle?.year?.model === 'other' && (
            <TextInput
              source="custom.model"
              label="Custom Model"
              validate={[required()]}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          {!(trimList.length === 1 && vehicle?.year?.trim === 'other') && (
            <AutocompleteInput
              label="Trim"
              source="year.trim"
              choices={trimList}
              validate={trimValidations}
              onChange={(value) => handleChange('trim', value)}
              options={{
                disabled: trimList.length === 0,
                error: hasTrimError,
              }}
              helperText={hasTrimError && 'Required'}
              onBlur={handleTouched('trim')}
            />
          )}

          {vehicle?.year?.trim === 'other' && (
            <TextInput
              source="custom.trim"
              label="Custom Trim"
              validate={trimValidations}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <AutocompleteInput
            label="Color"
            source="year.color"
            choices={commonVehicleColors}
            onChange={(value) => handleChange('color', value)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default YMMTForm;
